import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from 'shared/consts'
import { useSelector } from 'react-redux'
import styles from './DesktopNavigation.module.scss'

export const DesktopNavigation = () => {
  const { data } = useSelector(({ authStore }) => authStore.authorizedUser)
  return (
    <div className={styles.wrapper}>
      <Link to={ROUTES.ALL_SESSIONS}>Wszystkie nagrania</Link>
      <a href="https://nastrazy.org/" target="_blank" rel="noreferrer">
        Nastrazy.org
      </a>
      {data && <Link to="/dashboard">Panel użytkownika</Link>}
      {/* <Link to={ROUTES.ALL_SESSIONS}>Zgłoś problem</Link> */}
    </div>
  )
}
